import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ContentNotificationTypesGrid } from '@/modules/configurationModule/detail/notifications/components/notification-types-grid/notification-types-grid.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class GlobalNotificationConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<ContentNotificationTypesGrid>> {
        const response = await this.axios.put(`/configuration/notificationConfiguration`, filterModel, { params })
        return response.data
    }
    async getGlobalNotificationById(notificationConfigurationId: number): Promise<ContentNotificationTypesGrid> {
        const response = await this.axios.get(`/configuration/notificationConfiguration/${notificationConfigurationId}`)
        return response.data
    }
    async patchGlobalNotificationBatch(request: ContentNotificationTypesGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/notificationConfiguration/batch`, request)
        return response.data
    }
    async createGlobalNotification(request: ContentNotificationTypesGrid): Promise<ContentNotificationTypesGrid> {
        const response = await this.axios.post(`/configuration/notificationConfiguration`, request)
        return response.data
    }
    async deleteGlobalNotificationBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/notificationConfiguration/batch`, { data: request })
        return response.data
    }
}

export const globalNotificationConfigurationServices = new GlobalNotificationConfigurationServices()
